import Hero from "../components/Hero";
// import Partners from "../components/Partners";
import EventsPreview from "../components/EventsPreview";
import Gallery from "../components/Gallery";
import KolektifGroups from "../components/KolektifGroups";
// import Sponsors from "../components/Sponsors";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />
      <EventsPreview />
      <KolektifGroups />
      {/* <Partners /> */}
      <Gallery />
      {/* <Sponsors /> */}
    </div>
  );
};

export default Home;
